import { TReactEditor, insertNodes } from "@udecode/plate-core";
import { ELEMENT_ORNAMENTAL_BREAK } from "../createOrnamentalBreakPlugin";

export const insertOrnamentalBreak = (
  editor: TReactEditor,
): void => {
  insertNodes(
    editor,
    {
      type: ELEMENT_ORNAMENTAL_BREAK,
      children: [{ text: "" }],
    },
    {
      at: editor.selection || undefined,
    }
  );
};